// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1CtkOLb2Ej3v3qMQewulsY","position":"DAZQMsuSeTBMCEZ-c6Z5E","animation":"_1BDp6TtA8VQKbk0rrNPLUl","show":"_3SW2zxaJ7VAmlQHvts8eqM","content":"_16oqcaUVX_bjoNXxNBcLDs","group":"_2UKPrVIsGEr0RHC0_WiC04","link":"_1k2vyiUqR85xDDTjvW2ir6","listLink":"_2nyngHNz2K26HFCAaMAkhh","ctaLink":"diOUzG7TItsi90MIjN5Ug"};


//////////////////
// WEBPACK FOOTER
// ./ui/Popover.module.css
// module id = 2420
// module chunks = 0